import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/FounderCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn","Stagger","FadeInStaggerItem"] */ "/workspace/components/ui/motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PixelTrailGrid"] */ "/workspace/components/ui/PixelTrailGrid.tsx");
